import { useAnalytics, useUrlState } from "@zennya/web-component-library/src";
import { bookingState } from "pages/CustomerBooking/RecoilState";
import { useCallback } from "react";
import { useRecoilValue } from "recoil";
import { useUserState } from "services/authentication.service";
import { logEvent } from "services/logging";

const convertTrackToZennyaLog = ({ actor=null, client, name, bookingDetail, bookingId, medium, props }, retainProps) => {
  if (!bookingId) return
  const stringProps = JSON.stringify(props)
  let atTimeStatus = bookingDetail?.scheduled_status ?? ''
  if (bookingDetail?.status) {
    atTimeStatus = `${atTimeStatus} ${bookingDetail?.status}`
  }
  if (bookingDetail?.is_whitelabel) {
    atTimeStatus = `${atTimeStatus} Whitelabel`
  }
  if (bookingDetail?.is_confirmed) {
    atTimeStatus = `${atTimeStatus} Confirmed`
  }
  if (bookingDetail?.is_primary) {
    atTimeStatus = `${atTimeStatus} Primary`
  }
  const actorString = actor?.id ? `${actor?.id} | ${actor?.first_name} ${actor?.last_name} ` : 'Unauthenticated '
  const logMessage = [
    actorString,
    `triggered event:(${name})`,
    ' for Request: ',
    bookingId,
    ',Medium:',
    medium,
    ...retainProps ? [
      // ',Status:',
      // atTimeStatus?.toUpperCase(),
      ',Props:',
      stringProps,
    ] : []
  ].join('')  

  const payload = {
    log_message: logMessage,
    actor: actor?.id,
    client: client,
    request_id: bookingId,
    
  }
  
  logEvent(payload)

}

export const useTrackEvent = (bookingId) => {
  const { trackEvent, eventPrefix } = useAnalytics();
  const booking = useRecoilValue(bookingState)
  const [medium, setMedium] = useUrlState({
    queryKey: 'medium',
    defaultValue: 'WEB',
  });
  const user = JSON.parse(localStorage.getItem("user"))

  const doTrackEvent = useCallback(
    async (name, props, {retainProps}={retainProps:false}) => {
      const bookingDetail = booking?.id ? {
        status: booking?.status,
        scheduled_status: booking?.scheduled_status,
        is_confirmed: ((booking?.is_whitelabel && booking?.isConfirmed) || !booking?.is_whitelabel),
        is_primary: booking?.is_primary,
        is_whitelabel: booking?.is_whitelabel
      } : {}

      const trackProps = {
        booking_id: booking?.id || bookingId?.booking_id || bookingId,
        ...bookingDetail,
        medium,
        ...props
      }
      await trackEvent(`${eventPrefix} ${name}`, trackProps);
      const zennyaLogMessage = convertTrackToZennyaLog({
        name: `${eventPrefix} ${name}`,
        bookingDetail,
        actor: user?.user,
        client: booking?.client?.id,
        bookingId: booking?.id || bookingId?.booking_id || bookingId,
        medium,
        props
      }, retainProps)
      
    },
    [medium],
  );

  return doTrackEvent;
}

export const useTrackPage = (bookingId, {retainProps}={retainProps:false}) => {
  const { pageViewed, eventPrefix } = useAnalytics();
  const booking = useRecoilValue(bookingState)
  const [medium, setMedium] = useUrlState({
    queryKey: 'medium',
    defaultValue: 'WEB',
  });
  const user = JSON.parse(localStorage.getItem("user"))

  const doTrackPage = useCallback(
    async (name, props) => {
      const bookingDetail = booking?.id ? {
        status: booking?.status,
        scheduled_status: booking?.scheduled_status,
        is_confirmed: ((booking?.is_whitelabel && booking?.isConfirmed) || !booking?.is_whitelabel),
        is_primary: booking?.is_primary,
        is_whitelabel: booking?.is_whitelabel
      } : {}

      const trackProps = {
        booking_id: booking?.id || bookingId?.booking_id || bookingId,
        ...bookingDetail,
        medium,
        ...props
      }
      pageViewed(`${eventPrefix} ${name}`, trackProps);
      const zennyaLogMessage = convertTrackToZennyaLog({
        name: `${eventPrefix} ${name}`,
        bookingDetail,
        actor: user?.user,
        client: booking?.client?.id,
        bookingId: booking?.id || bookingId?.booking_id || bookingId,
        medium,
        props
      },
      retainProps)
      
    },
    [medium]
  );
  return doTrackPage;
}